import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { List } from 'features/profile/list'
import { Container } from 'ui/container'
import { PageTitle } from '../../features/common/page-title'
import { useAdminCheck } from 'core/hooks/useAdminCheck'
import { routes } from 'core/routes/paths'
import c from './assets/sass/page.module.scss'

const ProfilePage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { isAdmin } = useAdminCheck()

    const handleFAQ = () => {
        navigate('/faq?category=shop')
    }

    return (
        <div className={c.component}>
            <PageTitle title={t('tabs.profile')} callback={handleFAQ} />
            <Container>
                {isAdmin && (
                    <button
                        className={c.adminBtn}
                        onClick={() => navigate(routes.admin)}
                    >
                        {t('profile.user.adminPanel')}
                    </button>
                )}
                <List />
            </Container>
        </div>
    )
}

export default ProfilePage
